import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { getLastResults, getDetailResults } from '../../../../apiservices/CasionApi';
import RefResultModal from '../../../casinoComponents/refResultModal';
import Poker20ResultBody from '../../../casinoComponents/refResultModal/Poker20ResultBody';
import { formatRefMatchTime } from '../../../../utils/refMatchTime';

// Reference: win 1 → <span class="resulta">A</span>, 2 → <span class="resultb">B</span>, 0 → <span>T</span>
const item = (win) =>
  win === '1' ? { cls: 'resulta', text: 'A' } : win === '2' ? { cls: 'resultb', text: 'B' } : { cls: '', text: win === '0' ? 'T' : '' };

/**
 * Last Result items for 20-20 Poker (poker20) in the reference markup (rendered inside
 * `.casino-video-last-results`). Click → full-page .loader-overlay while the round detail loads,
 * then the reference result modal with Poker20ResultBody. Last results reload when the round changes.
 */
const ResultPoker20 = ({ data = [], gameData = {}, roundId }) => {
  const [lastResults, setLastResults] = useState([]);
  const [detailResult, setDetailResult] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const mid = roundId ?? gameData?.data?.data?.mid;

  useEffect(() => {
    const fetchLastResults = async () => {
      try {
        const response = await getLastResults('poker20');
        if (response?.data?.data?.res) {
          setLastResults(response.data.data.res.map((r) => ({ mid: r.mid, win: String(r.win) })));
        }
      } catch (e) {
        console.error('Error fetching last results:', e);
      }
    };
    fetchLastResults();
  }, [mid]);

  const handleResultClick = async (r) => {
    if (!r?.mid || loading) return;
    setLoading(true);
    try {
      const response = await getDetailResults('poker20', r.mid.toString());
      const t1 = response?.data?.data?.t1 ?? response?.data?.t1;
      if (t1) {
        setDetailResult(t1);
        setShowModal(true);
      }
    } catch (e) {
      console.error('Error fetching detail results:', e);
    }
    setLoading(false);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setDetailResult(null);
  };

  // API results; before they arrive, the feed's lrs ({mid, win}) as a fallback
  const items = lastResults.length > 0
    ? lastResults
    : (Array.isArray(data) ? data : [])
        .filter((r) => r && typeof r === 'object')
        .map((r) => ({ mid: r.mid, win: String(r.win) }));

  return (
    <>
      {items.map((r, index) => {
        const { cls, text } = item(r.win);
        return (
          <span key={r.mid || index} className={cls || undefined} onClick={() => handleResultClick(r)}>
            {text}
          </span>
        );
      })}
      {loading && createPortal(<div className="loader-overlay" />, document.querySelector('.page-content') || document.body)}
      <RefResultModal
        show={showModal && !loading && !!detailResult}
        onHide={handleCloseModal}
        title={`${detailResult?.ename || '20-20 Poker'} Result`}
        roundId={detailResult?.rid}
        matchTime={formatRefMatchTime(detailResult?.mtime)}
      >
        {detailResult ? <Poker20ResultBody t1={detailResult} /> : null}
      </RefResultModal>
    </>
  );
};

export default ResultPoker20;
